module.exports = __webpack_public_path__ + "img/777-b5c2de.png";